export enum EnumApiTonghao {
  Moments = '/moment/api/moments/mix/bytopic',
  FollowsMoments = '/moment/api/moments/follows',
  RecommendCitys = '/party/api/guild/recommend/list',
  Myself = '/party/api/guild/myself',
  GuildList = '/party/api/guild/list',
  GuildEstablished = '/party/api/guild/established',
  GuildDetail = '/party/api/guild/detail'
}
